import { render } from "./ProjectSerialNoUpdate.vue?vue&type=template&id=b3a39b36&scoped=true"
import script from "./ProjectSerialNoUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectSerialNoUpdate.vue?vue&type=script&lang=js"

import "./ProjectSerialNoUpdate.vue?vue&type=style&index=0&id=b3a39b36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a39b36"]])

export default __exports__